var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1V4M20 4V7M20 4H23M20 4H17",
    stroke: "#392118",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4V10H7",
    stroke: "#392118",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20V14H17",
    stroke: "#392118",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.0015L5.64 5.64154C6.71475 4.56625 8.04437 3.78075 9.50481 3.35831C10.319 3.12281 11.159 3.00443 12 3.00391M23 14.0015L18.36 18.3615C17.2853 19.4368 15.9556 20.2223 14.4952 20.6448C13.0348 21.0672 11.4911 21.1128 10.0083 20.7773C8.52547 20.4418 7.1518 19.7361 6.01547 18.7261C4.87913 17.7161 4.01717 16.4348 3.51 15.0015",
    stroke: "#392118",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSync);
export default __webpack_public_path__ + "static/media/new-sync.c122200ce82a9a42143e1b4d9dad3027.svg";
export { ForwardRef as ReactComponent };